export default __webpack_public_path__ + "static/media/Boomstore2.f2d5ee89.png";